<script setup lang="ts">
import { toRefs } from "vue";

const props = withDefaults(
  defineProps<{
    heading: string;
    description?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    showLoader?: boolean;
    open: boolean;
  }>(),
  {
    description: "This action  cannot be undone",
    confirmButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
    showLoader: false,
  },
);

const {
  heading,
  description,
  confirmButtonText,
  cancelButtonText,
  showLoader,
} = toRefs(props);

const emit = defineEmits<{
  (e: "onCancel"): void;
  (e: "onConfirm"): void;
}>();

const onCancel = () => {
  emit("onCancel");
};

const onConfirm = () => {
  emit("onConfirm");
};
</script>

<template>
  <pn-modal @close="onCancel" :open="open">
    <form class="form">
      <div :class="[{ spinner: showLoader }]">
        <pn-spinner size="3" v-show="showLoader" />
      </div>
      <h2 class="pn-l text-left">{{ heading }}</h2>
      <p class="text-left">{{ description }}</p>
    </form>

    <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
    <div slot="buttons">
      <div class="button-row">
        <pn-button
          appearance="light"
          variant="outlined"
          class="cancel-btn"
          @pnClick="onCancel"
          >{{ cancelButtonText }}</pn-button
        >
        <pn-button
          @pnClick="onConfirm"
          appearance="warning"
          class="confirm-btn"
          >{{ confirmButtonText }}</pn-button
        >
      </div>
    </div>
  </pn-modal>
</template>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
}
.form h2 {
  margin: 0;
}
.form p {
  margin-bottom: 0;
}
pn-modal .pn-modal > .pn-modal-content {
  padding: 24px !important;
}
pn-modal .pn-modal > [slot="buttons"] {
  padding: 24px;
}
pn-modal .pn-modal > [slot="buttons"] > * {
  margin: 0 0 0 0.5em;
}
.button-row {
  display: flex;
  gap: 16px;
}

@media (max-width: 768px) {
  .button-row {
    flex-direction: column;
  }
  .cancel-btn {
    order: 2;
  }
  .confirm-btn {
    order: 1;
  }
}
</style>
